export default __webpack_public_path__ + "static/media/icon-alert-alert.d0728114.svg";